/* tslint:disable */
/* eslint-disable */
/**
 * RCS.Carbon.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CacheEntryInfo
 */
export interface CacheEntryInfo {
    /**
     * 
     * @type {string}
     * @memberof CacheEntryInfo
     */
    key?: string;
    /**
     * 
     * @type {number}
     * @memberof CacheEntryInfo
     */
    sizeBytes: number;
    /**
     * 
     * @type {Date}
     * @memberof CacheEntryInfo
     */
    cachedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CacheEntryInfo
     */
    lastAccessed?: Date;
}

/**
 * Check if a given object implements the CacheEntryInfo interface.
 */
export function instanceOfCacheEntryInfo(value: object): value is CacheEntryInfo {
    if (!('sizeBytes' in value) || value['sizeBytes'] === undefined) return false;
    return true;
}

export function CacheEntryInfoFromJSON(json: any): CacheEntryInfo {
    return CacheEntryInfoFromJSONTyped(json, false);
}

export function CacheEntryInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CacheEntryInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'] == null ? undefined : json['key'],
        'sizeBytes': json['sizeBytes'],
        'cachedAt': json['cachedAt'] == null ? undefined : (new Date(json['cachedAt'])),
        'lastAccessed': json['lastAccessed'] == null ? undefined : (new Date(json['lastAccessed'])),
    };
}

export function CacheEntryInfoToJSON(json: any): CacheEntryInfo {
    return CacheEntryInfoToJSONTyped(json, false);
}

export function CacheEntryInfoToJSONTyped(value?: CacheEntryInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'sizeBytes': value['sizeBytes'],
        'cachedAt': value['cachedAt'] == null ? value['cachedAt'] : value['cachedAt'].toISOString(),
        'lastAccessed': value['lastAccessed'] == null ? value['lastAccessed'] : value['lastAccessed'].toISOString(),
    };
}

